import { FormattedMessage } from 'react-intl';
import { NoValue } from '../../../sharedComponents/NoValue';
import { Vehicle, VehicleInLoad } from '../../compoundManagement.types';

export const DisplayDispatchType = ({ vehicle }: { vehicle: Vehicle | VehicleInLoad }) => {
    return vehicle.vehicleType === undefined ? (
        <NoValue />
    ) : (
        <div className="ellipsis-1">
            <FormattedMessage id={`outboundOrderBook.common.vehicleType.${vehicle.vehicleType}`} />
        </div>
    );
};
